import apiClient from './axiosClient';

const getDistinctRequest = async (
  collection: 'jobs' | 'programs',
  fieldName: string,
  params: { coordinates?: [number, number]; distance?: string, region?: string, page?: number },
) => {
  return apiClient
    .get(`${collection}/distinct/${fieldName}`, { params })
    .then((res) => res.data);
};

export default getDistinctRequest;
